/**
 * Which paths are CLIENT-FACING — reachable with no STAFFED session at all.
 *
 * ROOT CAUSE this exists (Jun 2026): a real client finished a live card
 * payment, Stripe returned them to `/payment-success?session_id=...`, and the
 * app sent them to the STAFFED SIGN-IN PAGE. The success route itself is
 * public, and its own status call needs no auth — but the global providers
 * mounted above the router (notifications, badges, `/auth/me`) fire on every
 * page, and for a visitor with no session they answer 401. On the second 401
 * the axios interceptor did `window.location.href = '/login'`. The owner never
 * saw it because an admin session in their browser made those calls succeed.
 *
 * A paying client must never be shown a sign-in form or a product marketing
 * page. Anything listed here is a page a client can legitimately be on, so an
 * auth failure there is a background detail, never a reason to redirect.
 *
 * Keep in step with the public-route branch in App.js.
 */

const EXACT = [
  '/payment-success',
  '/live-experience',
  '/card',
  '/check-availability',
  '/embed/lead-form',
  '/terms',
  '/privacy',
];

const PREFIXES = [
  '/client-view/',
  '/songs/',
  '/feedback/',
  '/live/',
  '/brief/',
  '/event-command/',
  '/event/',
  '/call/',
];

export function isClientFacingPath(pathname) {
  const path = String(pathname || '').split('?')[0].replace(/\/+$/, '') || '/';
  if (EXACT.includes(path)) return true;
  return PREFIXES.some((p) => path.startsWith(p));
}

export default isClientFacingPath;
